import Styles from "./Display.module.scss";
import classnames from "classnames"

//Icons

import LightIcon from "../../../../icons/settings/mobile_settings/light_mode.png"
import DarkIcon from "../../../../icons/settings/mobile_settings/dark_mode.png"
import RadioBoxGroup from "../../../radio-group/RadioGroup";
import RadioButton from "../../../radio-group/radio-button/RadioButton";
import { useState } from "react";
import AppSlider from "../../../app-slider/AppSlider";
import Switch from "../../../switch/Switch";


interface DisplayProps{
    customClass?:string;
}

const Display = ({customClass}:DisplayProps) => {


    const [isDarkTheme, setIsDarkTheme] = useState(document.body.classList.contains("dark"))

    const [settings, setSettings] = useState(
        {
            brightness: Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100 : 100,
            saturation: 100
        }
    )

    const handleAddTheme = () => {
        document.body.classList.add("dark");
        setIsDarkTheme(true)
    }
    const handleRemoveTheme = () => {
        document.body.classList.remove("dark");
        setIsDarkTheme(false)
    }


    const handleBirghtness = (value: any) => {
        setSettings({
            ...settings,
            brightness: value
        })
        document.documentElement.style.setProperty(('--brightness'), String(value / 100))
    }


    return (
        <div className={classnames(Styles.container, customClass && customClass)}>
            <div className={classnames(Styles.themes_container, "solid_bg")}>
                <div className={Styles.themes}>
                    <div className={Styles.theme_container} onClick={handleRemoveTheme}>
                        <div className={Styles.image_container}>
                            <img src={LightIcon} />
                        </div>
                        <div className={classnames(Styles.label, !isDarkTheme && Styles.active)}>
                            Light
                        </div>
                        <div className={Styles.checkBox}>
                            <RadioButton size="small" id={"light"} value={"light"} isChecked={!isDarkTheme} handleOptionClick={() => { }} />
                        </div>
                    </div>

                    <div className={Styles.theme_container} onClick={handleAddTheme}>
                        <div className={Styles.image_container}>
                            <img src={DarkIcon} />
                        </div>
                        <div className={classnames(Styles.label, isDarkTheme && Styles.active)}>
                            Dark
                        </div>
                        <div className={Styles.checkBox}>
                            <RadioButton size="small" id={"dark"} value={"dark"} isChecked={isDarkTheme} handleOptionClick={() => { }} />
                        </div>
                    </div>
                </div>

                <div className={Styles.option} style={{border:"none"}}>
                    Dark mode Settings
                </div>
            </div>

            <div className={classnames(Styles.brightness, "solid_bg")}>

                <div className={Styles.option}>
                    <AppSlider currentVal={settings.brightness} minValue={0} maxValue={100} title="Brightness" onChange={handleBirghtness} />
                </div>

                <div className={Styles.option}>
                    Adaptive Brightness
                    <Switch isChecked={false}/>
                </div>

                <div className={Styles.option} style={{border:"none"}}>
                    Extra Brightness
                    <Switch isChecked={false}/>
                </div>
            </div>
        </div>
    )
}

export default Display
